// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".creation-date-drawer-mobile[data-v-7a8743c9]{bottom:0;left:0;overflow-y:auto;position:fixed!important;right:0;top:0;z-index:999999!important;-webkit-overflow-scrolling:touch}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
